import CategoryCard from '@/components/base/CategoryCard';
import { categories } from '@/mocks/articles';

export default function CategorySection() {
  return (
    <section className="w-full px-6 md:px-10 py-20 bg-background-100">
      <div className="text-center mb-12">
        <p className="text-accent-500 text-sm font-medium tracking-widest mb-2">CATEGORIES</p>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
          内容分类
        </h2>
        <p className="mt-3 text-foreground-500 text-sm max-w-xl mx-auto">
          探索不同主题的校园故事，总有一个栏目能触动你的心
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories.map((cat) => (
          <CategoryCard key={cat.slug} category={cat} />
        ))}
      </div>
    </section>
  );
}